/**
 * Indicator id → chart/UI label. Keep this module import-free so indicatorMeta and StockChart
 * never pull a partial `engine` bundle during circular / HMR loads (INDICATOR_OPTIONS undefined).
 */
export const INDICATOR_OPTIONS = {
  ev_ebitda: "EV/EBITDA Yield",
  ev_ebitda_z: "EV/EBITDA Yield (Z-score vs avg)",
  div_yield: "Dividend Yield",
  div_yield_z: "Dividend Yield (Z-score vs avg)",
  pb_ratio: "P/B Ratio (Z-score vs avg)",
  pe_ratio: "P/E Ratio (Z-score vs avg)",
  pe_dev: "P/E Deviation (vs 5y median)",
  poi_ratio: "P/Operating Income (Z-score vs avg)",
  ps_ratio: "P/S Ratio (Z-score vs avg)",
  peg_ratio: "PEG Ratio",
  fgpz: "FGPZ (Forward Growth Premium Z)",
  gag: "GAG (Growth Acceleration Gap)",
  revenue_cagr: "Revenue CAGR (1y, 2y & fwd est)",
  eps_cagr: "EPS CAGR (1y, 2y & fwd est)",
  mean_rev: "Mean reversion",
  syo: "SYO (Composite Yield Oscillator)",
  rmo: "RMO (Revenue Momentum Oscillator)",
  tamo: "TAMO (Total Assets Momentum Oscillator)",
  nimo: "NIMO (Net Income Momentum Oscillator)",
  vmz: "VMZ (Value-Momentum Z-Score)",
  srm: "SRM (Risk Metric)",
  oey: "Owner Earnings Yield",
  vmo: "Valuation Momentum (Δz)",
  mrvz: "MRVZ (Turnover-based MVRV-like Z)",
  vddm: "VDD Multiple (Value Days Destroyed)",
  nupl: "NUPL (equity proxy)",
  realized_price_252: "Realized Price (252d VWAC)",
  realized_price_504: "Realized Price (504d VWAC)",
  realized_price_5y: "Realized Price (5y VWAC)",
  risk: "Composite Risk (0–100)",
  pe_peratio: "P/E Ratio Comparison (Historical/Forward)",
  forward_pe: "Forward P/E (NTM consensus)",
  ttm_pe: "TTM P/E (trailing EPS)",
  rev_val: "Revenue Valuation (Price vs Revenue-Based Fair Value)",
  eps_val: "EPS Valuation (Price vs EPS-Based Fair Value)",
  cf_price: "Price/Cash Flow (Z-score vs avg)",
  cnf_combo: "Combined Classic/Novel Fundamental",
  shares_outstanding: "Shares Outstanding",
};
